// extracted by mini-css-extract-plugin
export default {"affiliateCardText":"affiliateCard_affiliateCardText__s4nu3","affiliateCardName":"affiliateCard_affiliateCardName__E-zy4"};